import { createSlice } from "@reduxjs/toolkit";
import { TipoDocumentoModel } from "../../../models/tipoDocumento/tipoDocumentoModel";
import { buscarTipoDocumento } from "../../../services/tipoDocumentoService";
import { resetAll } from "../../actions/actions";

export interface TipoDocumentoState {
  //buscar tipo documento
  loading: boolean;
  entity: TipoDocumentoModel;
  busca: string | null;
  list: TipoDocumentoModel[];
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: TipoDocumentoState = {
  //buscar tipo documento
  loading: false,
  entity: {} as TipoDocumentoModel,
  busca: null,
  list: [],
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const tipoDocumentoSlice = createSlice({
  name: "tipoDocumento",
  initialState,
  reducers: {
    //buscar tipo documento
    setBuscaTipoDocumento: (state, action) => {
      state.busca = action.payload;
    },
    setEntityTipoDocumento: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarTipoDocumento: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarTipoDocumento: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar tipo documento
    builder.addCase(buscarTipoDocumento.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTipoDocumento.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTipoDocumento.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar tipo documento
  setBuscaTipoDocumento,
  setEntityTipoDocumento,
  //internal
  setModalCadastrarTipoDocumento,
  setModalDeletarTipoDocumento,
} = tipoDocumentoSlice.actions;

export default tipoDocumentoSlice.reducer;
